import React from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import "../Useful/useful.css";
import AddSetting from "../Setting/Add_setting";
import "./setting.css";
import NoImage from "../../image-add.png";
import { ModalDetail } from "../Useful/Useful";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  SettingGet,
  SettingCreate,
  SettingDelete,
  SettingGetById,
  SettingUpdate,
  UploadFile,
} from "../../fetch";

export default class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      existData: {},
      error: null,
      data: [],
      isAdd: true,
      isEdit: false,
      page: 0,
      rowsPerPage: 20,
      loading: false,
      datalength: 0,
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  getList = () => {
    this.setState({ loading: true });
    SettingGet(this.state.page, this.state.rowsPerPage)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.success) {
          this.setState({ loading: false });
          this.setState({ data: response.result, datalength: response.count });
        } else {
          console.log(response.message);
          this.setState({ loading: true });
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: true });
        toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
      });
  };

  onFormSubmit(data) {
    if (data.key === "" || data.title === "") {
      if (data.key === "") {
        toast.error(" کلید وارد نشده است");
      }

      if (data.title === "") {
        toast.error(" عنوان وارد نشده است");
      }

      return false;
    }

    if (data.id !== "") {
      SettingUpdate(data)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          var query = this.state.data.find((q) => q.id === data.id);
          query.key = data.key;
          query.title = data.title;
          query.desc = data.desc;
          query.picUrl = data.picUrl;

          this.setState({ isAdd: true, isEdit: false });
          toast.success("عملیات با موفقیت انجام شد ...!");
          return null;
        })
        .catch((error) => {
          console.log(error);
          return null;
        });
    } else {
      data.id = "";
      SettingCreate(data)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.setState((prevState) => ({
            data: [...prevState.data, response.result],
          }));
          this.setState({ isAdd: true, isEdit: false });
          toast.success("عملیات با موفقیت انجام شد ...!");
          return null;
        })
        .catch((error) => {
          console.log(error);
          toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
          return null;
        });
    }
  }

  handleDelete = (id) => {
    if (id === "") {
      toast.warn("شناسه ای برای ادامه عملیات وجود ندارد");
      return;
    }
    confirmAlert({
      title: "توجه",
      message: "اطلاعات مورد نظر حذف خواهد شد",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            SettingDelete(id)
              .then((response) => {
                this.setState({
                  data: this.state.data.filter((item) => item.id !== id),
                });
                toast.success("اطلاعات مورد نظر حذف شد");
                return null;
              })
              .catch((error) => {
                console.log(error);
                toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
                return null;
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getList();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getList();
    });
  };

  render() {
    let setForm;
    if (this.state.isAdd || this.state.isEdit) {
      setForm = (
        <AddSetting
          onFormSubmit={this.onFormSubmit}
          fillData={this.state.existData}
        />
      );
    }

    return (
      <div>
        {setForm}
        <hr />
        <div className="col-lg-12  mypanel shadow">
          <Header_panel
            title="لیست تنظیمات"
            idMenu="#navbarToggleExternalContentSettingList"
          />
          <div className="pos-f-t">
            <div
              className="collapse"
              id="navbarToggleExternalContentSettingList"
            >
              <div className="p-4 mytable">
                <table className="table table-striped rtltable">
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>تصویر</th>
                      <th>کلید</th>
                      <th>عنوان</th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>
                          {item.picUrl ? (
                            <img
                              src={`https://macks-b.ir/${item.picUrl}`}
                              alt="raeen"
                              width="80"
                            />
                          ) : (
                            <img src={NoImage} alt="NoImage" width="80" />
                          )}
                        </td>
                        <td>{item.key}</td>
                        <td>{item.title}</td>
                        <td>
                          <ModalDetail
                            buttonLabel="توضیحات"
                            title="توضیحات"
                            description={
                              item.desc ? item.desc : "توضیحات ثبت نشده است"
                            }
                          ></ModalDetail>
                        </td>
                        <td>
                          <ModalUpdate
                            buttonLabel="ویرایش"
                            title="ویرایش"
                            id={item.id}
                            onFormSubmit={this.onFormSubmit}
                          ></ModalUpdate>{" "}
                        </td>
                        <td>
                          {" "}
                          <Button
                            color="warning"
                            id="regDelbtn"
                            onClick={() => {
                              this.handleDelete(item.id);
                            }}
                          >
                            حذف
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {this.state.loading && (
          <CircularProgress size={30} className="buttonProgress" />
        )}
        <TablePagination
          // style={{ direction: "rtl" }}
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={this.state.datalength}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          labelRowsPerPage="تعداد نمایش :"
          nextIconButtonText="بعدی"
          backIconButtonText="قبلی"
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export class ModalUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      id: "",
      key: "",
      title: "",
      desc: "",
      picUrl: "",
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount = () => {
    SettingGetById(this.props.id)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this.setState({
          key: response.key,
          title: response.title,
          desc: response.desc,
          picUrl: response.picUrl,
        });
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  handleSelectFile = (event) => {
    if (event.target.files.length <= 0) {
      this.setState({ picUrl: "" });
      return false;
    }
    UploadFile(event.target.files[0])
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this.setState({ picUrl: response.pathFName });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggle() {
    this.setState({ modal: !this.state.modal, id: this.props.id });
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSubmit(event) {
    event.preventDefault();
    this.props.onFormSubmit(this.state);
    this.setState({ id: "", key: "", title: "", desc: "", picUrl: "" });
  }

  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <Form onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
            <ModalBody style={{ textAlign: "right" }}>
              <div className="row p-4">
                <div className="col-lg-12">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      * کلید{" "}
                    </label>
                    <input
                      value={this.state.key}
                      onChange={this.handleChange("key")}
                      className="contactInput form-control"
                      name="key"
                      placeholder="کلید..."
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      * عنوان
                    </label>
                    <input
                      value={this.state.title}
                      onChange={this.handleChange("title")}
                      className="contactInput form-control"
                      name="title"
                      placeholder="عنوان..."
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      توضیحات
                    </label>
                    <textarea
                      rows="2"
                      value={this.state.desc}
                      onChange={this.handleChange("desc")}
                      className="contactInput form-control"
                      name="title"
                      placeholder="متن..."
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label className="control-label" htmlFor="first_name">
                      آدرس فایل
                    </label>
                    <label style={{ fontsize: "10px" }}>
                      {this.state.picUrl}
                    </label>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label className="control-label" htmlFor="first_name">
                      انتخاب فایل
                    </label>
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="inputGroupFile01"
                        aria-describedby="inputGroupFileAddon01"
                        onChange={this.handleSelectFile}
                      />
                      <label
                        className="custom-file-label"
                        value={this.state.picUrl}
                        htmlFor="inputGroupFile01"
                      >
                        آدرس تصویر
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggle}>
                بستن
              </Button>
              <Button
                type="submit"
                color="primary"
                id="regProdbtn"
                onClick={this.toggle}
              >
                ذخیره
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}
